import { Theme } from "@mui/material";
import { getStaticAssetPath } from "../../utils/staticAssets";

// AuthLayout styles (factory)
export const createAuthLayoutStyles = (theme: Theme) => ({
  container: {
    minHeight: "100vh",
    bgcolor: theme.palette.background.default,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  logo: {
    color: "white",
  },

  backgroundImage: {
    position: "fixed",
    top: 0,
    left: 0,
    width: { xs: "100%", lg: "60%" },
    height: "100%",
    backgroundImage: `url(${getStaticAssetPath("images/loginBg.png")})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    bgcolor: "black",
    zIndex: 1,
  },
});

// TopBar styles (factory)
export const createTopBarStyles = (theme: Theme) => ({
  container: {
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  },

  appBar: {
    position: "fixed",
    elevation: 1,
    backgroundColor: theme.palette.materiom.seaweed,
    zIndex: theme.zIndex.appBar,
    borderRadius: "0px",
  },

  toolbar: {
    justifyContent: "space-between",
    minHeight: "54px !important",
    py: 0.25,
    alignItems: "center",
  },

  logoContainer: {
    display: "flex",
    alignItems: "center",
  },

  logo: {
    cursor: "pointer",
    color: "white",
    height: 32,
    position: "static",
    top: "auto",
    left: "auto",
  },

  desktopNavigation: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: 0,
    alignItems: "stretch",
    height: "100%",
  },

  navButton: (isActive: boolean) => ({
    color: "white",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: "bold",
    px: 2.5,
    py: 0,
    height: "100%",
    borderRadius: 0,
    minWidth: "auto",
    whiteSpace: "nowrap",
    backgroundColor: isActive ? "rgba(0, 0, 0, 0.15)" : "transparent",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  }),

  content: {
    pt: 6,
  },

  // Mobile navigation styles
  mobileMenuButton: {
    color: "white",
  },

  mobileMenuOverlay: {
    position: "fixed",
    top: 48, // Below the AppBar
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "white",
    zIndex: theme.zIndex.appBar - 1,
    overflow: "auto",
  },

  mobileNavSection: {
    pt: 1,
    pb: 1,
  },

  mobileNavItem: (isActive: boolean) => ({
    px: 4,
    py: 2,
    cursor: "pointer",
    backgroundColor: isActive ? "rgba(0, 0, 0, 0.05)" : "transparent",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  }),

  mobileNavItemText: (isActive: boolean) => ({
    color: isActive ? theme.palette.materiom.seaweed : "#222",
    fontSize: "16px",
    fontWeight: isActive ? "bold" : "normal",
  }),

  mobileUserSection: {
    pt: 2,
    pb: 2,
  },

  mobileUserInfo: {
    px: 4,
  },

  mobileUserName: {
    fontWeight: "500",
    fontSize: "16px",
    color: "#374151",
    mb: 0.5,
  },

  mobileUserEmail: {
    fontSize: "14px",
    color: "#6B7280",
    mb: 3,
  },

  mobileLogoutButton: {
    px: 4,
    py: 2,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
  },

  mobileLogoutText: {
    color: "#374151",
    fontSize: "16px",
  },

  // Desktop user profile styles
  userProfileContainer: {
    display: "flex",
    alignItems: "center",
  },

  userProfileButton: {
    p: 0.625, // 5px padding
    position: "relative",
  },
});
